// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__2WiPs","linkParagraph":"header_linkParagraph__hEU6s","mainStats":"header_mainStats__1jPZn","stats":"header_stats__CL5Jw"};